export const CHANNEL_SETTINGS_SYMBOL = Symbol("channelSettings");
